import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { map, switchMap } from 'rxjs/operators';
import { ModalAddTopicComponent } from '../../e-learning-management/modal-add-topic/modal-add-topic.component';
import { ProfileService } from '../profile.service';

@Component({
  selector: 'app-modal-avatar',
  templateUrl: './modal-avatar.component.html',
  styleUrls: ['./modal-avatar.component.scss']
})
export class ModalAvatarComponent implements OnInit {

  isLoading: boolean;
  modalData: any;
  type: string;
  profileForm: FormGroup;
  profileList;
  profilePic;
  pic;
  orgPic;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAddTopicComponent>,
    private fb: FormBuilder,
    private profileService: ProfileService
  ) {
    this.modalData = data;
    this.type = data.type;
  }

  ngOnInit(): void {
    // // console.log(this.data);
    this.isLoading = true;
    this.profileService.getAllAvatar().pipe(
      map(res => {
        // // console.log(res);
        this.profileList = res.result;
        this.isLoading = false;
      })
    ).subscribe();
  }

  selectAvatar() {
    const response = {
      status: true,
      value: this.profilePic
    }
    this.dialogRef.close(response);

  }

  formChange(item) {
    this.profilePic = item;
    // // console.log(this.profilePic);
  }

  closeModal() {
    const response = {
      status: false
    }
    // // console.log(response);
    this.dialogRef.close(response);
  }

}
